var map = {
	"./1_html5-original.svg": 762,
	"./2_css3-original.svg": 668,
	"./3_javascript-original.svg": 206,
	"./4_typescript-original.svg": 163,
	"./5_mongodb-original.svg": 395,
	"./6_express-original.svg": 910,
	"./7_react-original.svg": 943,
	"./8_nodejs-original.svg": 677,
	"./9_java-plain.svg": 8,
	"./a_python-original.svg": 182,
	"./b_php-original.svg": 714,
	"./c_android-plain.svg": 725,
	"./d_mysql-original.svg": 521,
	"./e_doctrine-plain.svg": 447,
	"./f_docker-original.svg": 792,
	"./g_tailwindcss-plain.svg": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 859;